import { render, staticRenderFns } from "./explain-product-analysis.view.vue?vue&type=template&id=4c6b3a88&scoped=true"
import script from "./explain-product-analysis.view.vue?vue&type=script&lang=ts"
export * from "./explain-product-analysis.view.vue?vue&type=script&lang=ts"
import style0 from "./explain-product-analysis.view.vue?vue&type=style&index=0&id=4c6b3a88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6b3a88",
  null
  
)

export default component.exports